import { formatCalendarDate } from '@lib/datetime'
import { countLabel } from '@/utils/plural'
import React from 'react'
import styled from 'styled-components'

interface TripHeaderProps {
	tripName: string
	dayCount: number
	startDate: string
	endDate: string
}

const Container = styled.div`
	display: flex;
	justify-content: center;
	padding: 3rem 1rem 1.5rem 1rem;
	flex-shrink: 0;
	margin-bottom: 5rem;
`

const HeaderStack = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.4rem;
`

const TripName = styled.span`
	font-size: 3rem;
	font-weight: 700;
	color: #212529;
`

const SubRow = styled.div`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	color: #6c757d;
	font-size: 0.95rem;
	font-weight: 500;
`

const DaysBadge = styled.span`
	padding: 0.4rem 1rem;
	background: white;
	color: #212529;
	border-radius: 20px;
	font-size: 0.95rem;
	font-weight: 600;
	white-space: nowrap;
	border: 2px solid #e9ecef;
`

const TripHeader: React.FC<TripHeaderProps> = ({ tripName, dayCount, startDate, endDate }) => {
	const formatDate = (date: string): string => {
		return formatCalendarDate(date, 'medium') || 'Not set'
	}

	return (
		<Container>
			<HeaderStack>
				<TripName>{tripName}</TripName>
				<SubRow>
					<DaysBadge>
						{countLabel(dayCount, 'Day')}
					</DaysBadge>
					<span>
						{formatDate(startDate)} to {formatDate(endDate)}
					</span>
				</SubRow>
			</HeaderStack>
		</Container>
	)
}

export default TripHeader
